import Banner from "./Banner";
import React, { useEffect } from "react";
import WebLayout from "layout/webLayout.js";
import { useNavigate } from "react-router-dom";

const DonateSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Banner />
      <div className="flex justify-center items-center">
        <div className="w-3/5 md:w-2/5 py-24 flex flex-col gap-6 justify-center items-center">
          <div className="flex flex-col gap-4 justify-center items-center">
            <p className="text-[#213874] text-[24px] font-bold text-center">
              Thank you for your donation
            </p>
            <p className="text-[#7A7A7A] text-[16px] text-center">
              Your donation would be confirmed by an admin. Click on sign up to
              get feedback on how your donation made an impact. You can donate
              money to this project by clicking on donate money.
            </p>
          </div>
          <div className="w-full">
            <button
              className="w-full h-[50px] rounded-3xl bg-[#213874] hover:bg-[#182d62] px-4 py-2"
              type="button"
              onClick={() => navigate("/auth/signup")}
            >
              <p className="text-white">Sign up</p>
            </button>
          </div>
          <div className="w-full">
            <button
              className="w-full h-[50px] rounded-3xl border border-[#213874] bg-white hover:bg-[#e4e6eb] px-4 py-2"
              type="button"
              onClick={() => navigate("/donate-money")}
            >
              <p className="text-black">Donate Money</p>
            </button>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default DonateSuccess;
